import { Component, ElementRef, HostListener, inject } from '@angular/core';
import { Api } from '../../../services/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nav-members',
  imports: [FormsModule, CommonModule],
  templateUrl: './nav-members.html',
  styleUrl: './nav-members.css'
})
export class NavMembers {

  public api = inject(Api);

  public campana_id: string = '';
  public members: any = [];
  public tipo: string = '';
  openedMenuId: string | null = null;
  showRecentDropdown: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private elementRef: ElementRef
  ){}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.campana_id = params['id'];
      this.getCampaignDetails();
    });
  }

  getCampaignDetails(){
    this.api.getCampaignById({campana_id: this.campana_id}).subscribe({
      next: (data:any)=>{
        console.log('Campaign data received:', data);
        this.tipo = data.campana.segmento.tipo_entidad === 'PRO' ? 'Prospecto' : data.campana.segmento.tipo_entidad === 'ACC' ? 'Cuenta' : 'Contacto';
        this.members = data.campana.segmento.entidades_detalle;
        for (let i = 0; i < data.campana.segmento.entidades.length; i++) {
          this.members[i].segmento_entidad_id = data.campana.segmento.entidades[i].segmento_entidad_id;
        }
        console.log('Campaign details:', this.members);
      },
      error: (err:any)=>{
        console.error('Error fetching campaign details:', err);
      }
    });
  }

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false; 
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
      if (!(target instanceof HTMLElement)) return;
      
      const clickedInsideRecent = this.elementRef.nativeElement.querySelector('.dropdown-trigger')?.contains(target);
      const clickedInsideActions = this.elementRef.nativeElement.querySelector('.dots-button')?.contains(target);
      
      if (!clickedInsideRecent) {
          this.showRecentDropdown = false;
      }
      
      if (!clickedInsideActions) {
          this.openedMenuId = null;
      }
  }
}
